<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full"
      :contentStyle="{'height': '100%'}"
      :footer="false">
    <template #header>
      <span>操作日志</span>
    </template>
    <template #content>
      <gj-log-table
          :url="url"
          :default-sort="defaultSort"
          adaptParent
          :op-type-option="opTypeOption"
          :method="method"
          :params="params"
          :columns="columns"
          :offset-height="6"
      ></gj-log-table>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "../../minxins";

  export default {
    name: "gj-log-modal",
    mixins: [modalMixIn, queryMixin],
    props: {
      url: {
        type: String,
      },
      opTypeOption: {
        default: null
      },
      method: {
        type: String,
        default: 'post'
      },
      params: {
        required: false,
        default: () => {}
      },
      defaultSort: {
        required: false,
        default: () => {}
      },
      columns: {
        type: Array,
        default: null,
      }
    },
  }
</script>

<style lang="scss" scoped>
  /deep/ .gj-modal--table{
    .el-dialog{
      height: 520px;
    }
  }
</style>
